import React from 'react';
import Tooltip from 'components/Tooltip/Tooltip';

import { PaymentVopMatchStatus } from '@alpha/payments-dtos/lib/enums/PaymentVopMatchStatus';
import { Box, TooltipProps } from '@alpha/ui-lib/ui/external';
import {
  faShieldCheck,
  faShieldExclamation,
  faShieldSlash,
  faShieldTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface VOPStatusBadgeProps {
  status: PaymentVopMatchStatus | undefined;
  message?: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const VOPStatusBadge = ({
  status,
  message,
  tooltipProps,
  onClick,
}: VOPStatusBadgeProps): JSX.Element => {
  const getShieldColor = (s?: PaymentVopMatchStatus) => {
    switch (s) {
      case PaymentVopMatchStatus.MATCH:
        return '#1E8777';
      case PaymentVopMatchStatus.NEAR_MATCH:
        return '#CF752F';
      case PaymentVopMatchStatus.NO_MATCH:
        return '#A62B23';
      case PaymentVopMatchStatus.FAILED:
      case PaymentVopMatchStatus.NOT_AVAILABLE:
        return '#1B1B1B40';
      default:
        return '#1B1B1B40';
    }
  };

  const getShieldIcon = (s: PaymentVopMatchStatus | undefined) => {
    switch (s) {
      case PaymentVopMatchStatus.MATCH:
        return faShieldCheck;
      case PaymentVopMatchStatus.NEAR_MATCH:
        return faShieldExclamation;
      case PaymentVopMatchStatus.NO_MATCH:
        return faShieldTimes;
      case PaymentVopMatchStatus.FAILED:
      case PaymentVopMatchStatus.NOT_AVAILABLE:
        return faShieldSlash;
      default:
        return faShieldSlash;
    }
  };

  return (
    <>
      <Tooltip title={message || ''} placement='top' {...tooltipProps}>
        <Box
          onClick={onClick}
          width={28}
          height={28}
          borderRadius={4}
          border='1px solid #eaeaea'
          padding='5px'
          boxShadow='0px 0.5px 1px 0px #00000014'
          justifyContent='center'
          fontSize='11px'
          style={{ cursor: onClick ? 'pointer' : 'default' }}
        >
          <FontAwesomeIcon
            icon={getShieldIcon(status)}
            color={getShieldColor(status)}
            style={{ marginLeft: getShieldColor(status) === '#1B1B1B40' ? '1px' : '3px', fontSize: '11px' }}
          />
        </Box>
      </Tooltip>
    </>
  );
};
export default VOPStatusBadge;
